import DigitalPracticeRAv2 from './component';
import Privileges from 'domain/Privileges';
import { PrivilegeChecker } from 'omni-common-ui';
import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';

export default ({ getState }) => ({
  path: 'digital-practice-ra-v2',
  component: DigitalPracticeRAv2,
  canAccess: ({ params }) =>
    PrivilegeChecker.hasPrivilege(getState(), Privileges.Homework.View) &&
    TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.DigitalPracticeRAv2),
  tab: {
    label: 'Digital Practice',
    order: 2,
    isVisible: (params) => {
      if (!PrivilegeChecker.hasPrivilege(getState(), Privileges.Homework.View)) {
        return false;
      }
      if (!TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.DigitalPracticeRAv2)) {
        return false;
      }
      return true;
    },
  },
  breadcrumbLabels: () =>
    [{
      label: 'Digital Practice',
      clickable: false,
    }],
});



// WEBPACK FOOTER //
// ./containers/Group/DigitalPracticeRAv2/routes.js